<template>
  <v-card class="mb-2 light-green lighten-4">
    <v-card-text v-if="selectLists">
      <div class="d-flex">
        <div class="mr-2">
          <v-icon :color="feature.services.color">{{ serviceTypeIcon }}</v-icon>
          <MapIcon
            class="mt-4"
            :street="ss.Address.Street"
            :city="ss.Address.City"
            :state="ss.Address.State"
            :postCode="ss.Address.PostCode"
          />
        </div>
        <div @click="editScheduledServiceClick">
          <div class="body-1 font-weight-black">{{ ss.ServiceType }}</div>
          <div>{{ ss.SiteName }}</div>
          <div>{{ ss.Address.Street }}, {{ ss.Address.City }}</div>
        </div>
        <v-spacer @click="editScheduledServiceClick" />
        <div @click="editScheduledServiceClick">
          <v-icon :color="feature.services.color">
            {{ feature.services.icon }}
          </v-icon>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, computed } from 'vue'
import { feature } from '@/use/Constants'
import { selectListCache } from '@/services/SelectListCache'
import MapIcon from '@/components/Common/MapIconExternal'
export default {
  name: 'ServiceListItemCard',
  components: {
    MapIcon
  },
  props: {
    ss: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const selectLists = ref()

    const editScheduledServiceClick = () => {
      context.emit('edit', props.ss.ScheduledServiceId)
    }

    const initDialog = () => {
      loadSelectLists()
    }

    const loadSelectLists = async () => {
      const selectListNames = [selectListCache.name.ServiceTypes]

      selectLists.value = await selectListCache.get(selectListNames)
    }

    const serviceTypeIcon = computed(() =>
      selectListCache.attribute(
        selectListCache.name.ServiceTypes,
        props.ss.ServiceTypeId,
        'IconName'
      )
    )

    initDialog()

    return {
      feature,
      selectLists,
      serviceTypeIcon,
      editScheduledServiceClick
    }
  }
}
</script>

<style lang="scss" scoped></style>
